module.exports = __webpack_public_path__ + "img/mizhi-back-second@2x.4e8b182d.png";